module.exports = __webpack_public_path__ + "img/consultation_part2.db0f1ac7.png";